/**
 * common theme
 */
const colors = {
  title: '#000000',
  body: '#555555',
  grayLine: '#E7E8EC',
  placeHolder: '#AAAAAA',
  primary500: '#B32651',
  error: '#FA2249',
  caption: '#999999',
  primaryBg: '#FFF4F7',
  grayIcon: '#333333',
  grayBgLight: '#f8f8f8',
  grayBgDark: '#A7A9AB',
  white: '#FFFFFF',
  disabled: '#C0C0C0',
  blueBg: '#46A7ED',
  blueLight: '#97CDFF',
  pinkBg: '#EF3F70',
  pinkLight: '#FF9FBA',
  grayIconBg: '#EEEEEE',
  dateBg: '#f0f0f0',
  klabRed: '#9C1B41',
  klabGray: '#D3D3D3',
  klabGray03: '#A7A7A7',
  klabDarkGray: '#333333',
  mainBg: '#2B2839',
  noticeBg: '#dddddd',
};
const langs = {
  indonesian: 'IND',
  english: 'EN',
};

/**
 * 회사 소개 페이지
 */
const intro = {
  productAndServices: 'Product & Services',
  news: 'News',
  examinationRequest: 'Test Request',
  worldClass: 'World Class',
  healthcarePartner: 'Healthcare Partner',
  home: 'Home',
  search: 'Search',
  medicalCheckUp: 'Medical Check Up',
  notice: 'Notice',
  newsletter: 'Newsletter',
  clinicalLaboratoryService: 'Clinical Laboratory Service',
  bySCLLXInternational: 'by SCL & LX International',
  aboutKLAB: 'About K-LAB',
  describtionAboutKLAB:
    'K-LAB is established by Seoul Clinical Laboratories(SCL), the very first clinical laboratory in Korea and LX International with more than 40 years working experiences in Indonesia.',
  learnMore: 'Learn More',
  oneStopSolution: 'One Stop Solution',
  describtionOneStopSolution:
    'K-LAB aims to be an independent clinical laboratory that provides the “One Stop Solution” for the sample collecting, testing, and reporting for the clinics and hospitals in Indonesia.',
  worldClassHealthcarePartner: 'World Class Healthcare Partner',
  describtionWorldClassHealthcarePartner:
    'We are dedicated to become the world class healthcare partner by providing the fast and advanced healthcare solution.',
  visionAndMission: 'Vision & Mission',
  mission: 'Misson',
  describtionMission:
    "By providing advanced diagnostic test services, K-LAB contributes to the growth of clinic and hospital partners, the development of the Indonesian medical system, and people's health care management.",
  vision: 'Vision',
  describtionVision:
    'K-LAB aims to be the world class healthcare partner by providing the fast and advanced healthcare solution.',
  slogan: 'Slogan',
  describtionSlogan: 'World Class Healthcare Partner',
  brochure: '2023 K-LAB Brochure',
  describtionBrochure: 'Learn more about K-LAB with our 2023 brochure',
  brochureDownload: 'View the 2023 K-LAB Brochure (PDF)',
  contactUs: 'Contact Us',
  name: 'Name',
  enterYourName: 'Enter your name',
  email: 'Email',
  enterYourEmail: 'Enter your email',
  phone: 'Phone',
  enterYourPhoneNumber: 'Enter your phone number',
  message: 'Message',
  enterYourMessage: 'Enter your message',
  bySendingAMessageYouAgreeToOur: 'By sending a message, you agree to our',
  and: 'And',
  termsAndConditions: 'Terms and Conditions',
  privacyPolicy: 'Privacy Policy',
  sendMessage: 'Send Message',
  location: 'Location',
  contact: 'Contact',
};

const texts = {
  signIn: 'Sign In',
  id: 'ID',
  email: 'Email',
  cancel: 'Cancel',
  send: 'Send',
  enterEmailAddress: 'Enter Email Address',
  enterClinicId: 'Enter Facility ID',
  password: 'Password',
  forgotPassword: 'Forgot Password?',
  enterPassword: 'Enter Password',
  success: 'Success',
  error: 'Error',
  createNewPassword: 'Create new password',
  enterANewPasswordBelow: 'Enter a new password below',
  newPassword: 'New password',
  enterCurrentPassword: 'Enter current password',
  enterNewPassword: 'Enter new password',
  pleaseEnterANewPassword: 'Please enter a new password',
  confirmPasword: 'Confirm password',
  reEnterPassword: 'Re-enter new password',
  passwordsDoNotMatch: 'Passwords do not match',
  changePassword: 'Change Password',
  passwordChanged: 'Password Changed',
  yourPasswordHasBeenChangedSuccessfully:
    'Your password has been changed successfully',
  backToSignIn: 'Back to Sign In',
  clientList: 'Patient List',
  search: 'Search',
  allRightReserver: 'K-LAB. All rights reserved.',
  noResultsFound: 'No results found',
  trySerchingForSomethingElse: 'Try searching for something else',
  rowsPerPage: 'Rows per page',
  plusAddNew: '+ Add New',
  plusAdd: '+ Add',
  newest: 'Newest',
  oldest: 'Oldest',
  no: 'No.',
  clientNo: 'Patient No.',
  name: 'Name',
  dateOfBirth: 'Date of Birth',
  gender: 'Gender',
  clientInformation: 'Patient Information',
  confirm: 'Confirm',
  newClient: 'New Patient',
  enterClientInformation: 'Enter Patient Information',
  next: 'Next',
  pleaseEnterTheRequiredInformation: 'Please enter the required information.',
  yes: 'Yes',
  notYes: 'No',
  pregnancy: 'Pregnancy',
  enterIDNumber: 'Enter ID Number',
  iDNumber: 'ID Number',
  nationality: 'Nationality',
  indonesia: 'Indonesia',
  foreigner: 'Foreigner',
  selectNationality: 'Select Nationality',
  selectGender: 'Select Gender',
  phone: 'Phone',
  enterPhoneNumber: 'Enter Phone Number',
  memo: 'Memo',
  optional: 'Optional',
  enterSomethingRelatedToTheClient: 'Enter something related to the patient.',
  male: 'Male',
  female: 'Female',
  passportNumber: 'Passport Number',
  enterPassportNumber: 'Enter Passport Number',
  pleaseCheckTheInformationYouEntered:
    'Please check the information you entered.',
  prev: 'Prev',
  save: 'Save',
  manage: 'Manage',
  edit: 'Edit',
  delete: 'Delete',
  back: 'Back',
  information: 'Information',
  dateOfRegistration: 'Date of Registration',
  deleteClient: 'Delete Patient',
  deleteClientAndContent: 'Delete Patient and Content',
  areYouSureYouWantToDeleteThisClient:
    'Are you sure you want to delete this client?',
  itWillBePermanentlyDeleted: 'It will be permanently deleted.',
  clinicInformation: 'Facility Information',
  enterClinicInformation: 'Enter Facility Information',
  clinicName: 'Facility Name',
  enterName: 'Enter Name',
  websiteOptional: 'Website (Optional)',
  faxOptional: 'Fax (Optional)',
  enterWebsite: 'Enter Website',
  enterFax: 'Enter Fax Number',
  streetAddress: 'Street Adress',
  aptSuiteEtcOptional: 'Apt, Suite, Etc (Optional)',
  city: 'City',
  zip: 'ZIP/Postcode',
  keywordSearch: 'Keyword Search',
  manager: 'Staff',
  resetPassword: 'Reset Password',
  support: 'Support',
  signOut: 'Sign Out',
  stillHaveQuestions: 'Still have questions?',
  cantFindTheAnswerYouReLookingFor: 'Can’t find the answer you’re looking for?',
  SendUsAnEmailAndWellGetAResponse:
    "Send us an email and we'll get a response.",
  slxEmail: 'laboratory_klab@lxintl.co.kr',
  slxPhone: '021-252-8549',
  exampleEmail: 'example@mail.com',
  clientAddSuccess: 'Create new patient successfully',
  testingInProgress: 'Test in Progress',
  newTest: 'New Test',
  notice: 'Notice',
  TestCompleted: 'Test Completed',
  seeAll: 'See All',
  today: 'Today',
  dateRange: 'Date Range',
  from: 'From',
  to: 'To',
  apply: 'Apply',
  testNo: 'Order No :',
  testName: 'Test Name',
  specimen: 'Specimen',
  client: 'Patient',
  updateSuccess: 'Update success',
  deleteSuccess: 'Delete success',
  createSuccess: 'Create success',
  testCanceled: 'Test Canceled',
  testProcessing: 'Test Processing',
  testList: 'Test List',
  status: 'Status',
  clientName: 'Patient Name',
  notification: 'Notification',
  testResultsHaveArrived: 'Test results have arrived.',
  orderHasBeenCompleted: 'Order has been completed.',
  yesterday: 'Yesterday',
  currentPassword: 'Current password',
  testCode: 'Test Code',
  testInformation: 'Test information',
  price: 'Price',
  requiredDay: 'TAT',
  testItem: 'Test Item',
  testDate: 'Test Date',
  totalPrice: 'Total Price',
  expectedDate: 'Expected Date',
  canceledDate: 'Canceled Date',
  testedDate: 'Tested Date',
  collectedDate: 'Collected Date',
  reportedDate: 'Reported Date',
  result: 'Result',
  referenceRange: 'Reference Ragne',
  comment: 'Comment',
  downloadTestReport: 'Download Test Report (PDF)',
  successCancel: 'Cancel successfully',
  goBack: 'Go Back',
  cancelTest: 'Cancel Order', //TODO:
  testResultPDFDownload: 'Download',
  testResultPDF: 'Download Result',
  thisTestIs: 'This test is',
  refundable: 'refundable',
  nonrefundable: 'nonrefundable',
  reasonForCancellation: 'Reason for Cancellation',
  eXchangePaymentMethod: 'ex) change payment method',
  deleteTest: 'Delete Order',
  areYouSureYouWantToDeleteThisTest:
    'Are you sure you want to delete this test?',
  managerType: 'Staff Type',
  selectClient: 'Select Patient',
  pleaseSelectAClientToBeTested: 'Please select a client to be tested.',
  selectTestItem: 'Select Test Item',
  pleaseSelectTestItems: 'Please select test items',
  newOrder: 'New Order',
  passwordResetEmailSuccess: 'Check your mail and click uri to reset',
  clinicNo: 'Facility No.',
  nik: 'NIK',
  lastMenstrualDate: 'Last Menstrual Date',
  day: 'Day',
  days: 'Days',
};

const textsIND: typeof texts = {
  ...texts,
  signIn: 'Masuk',
  cancel: 'Batalkan',
  send: 'Kirim',
  enterEmailAddress: 'Masukkan Alamat Email',
  enterClinicId: 'Masukkan ID Fasilitas',
  password: 'Kata Sandi',
  forgotPassword: 'Lupa Kata Sandi?',
  success: 'Berhasil',
  error: 'Terjadi kesalahan',
  createNewPassword: 'Buat Kata Sandi Baru',
  enterANewPasswordBelow: 'Masukkan kata sandi baru di bawah ini',
  newPassword: 'Kata Sandi Baru',
  enterCurrentPassword: 'Masukkan Kata sandi saat ini',
  enterNewPassword: 'Masukkan Kata Sandi Baru',
  pleaseEnterANewPassword: 'Silahkan masukkan kata sandi baru',
  confirmPasword: 'Konfirmasi kata sandi',
  reEnterPassword: 'Masukkan kembali kata sandi baru',
  passwordsDoNotMatch: 'Kata sandi tidak sesuai',
  changePassword: 'Ubah Kata Sandi',
  passwordChanged: 'Kata Sandi Berhasil Diubah',
  yourPasswordHasBeenChangedSuccessfully: 'Kata sandi Anda berhasil diubah',
  backToSignIn: 'Kembali ke Masuk',
  clientList: 'Daftar Pasien',
  search: 'Pencarian',
  allRightReserver: 'K-LAB.Hak cipta dilindungi undang-undang.',
  noResultsFound: 'Pencarian tidak ditemukan',
  trySerchingForSomethingElse: 'Coba cari sesuatu yang lain',
  rowsPerPage: 'Baris per halaman',
  plusAddNew: '+ Tambahkan baru',
  plusAdd: '+ Tambahkan',
  newest: 'Terbaru',
  oldest: 'Sebelumnya',
  no: 'No.',
  clientNo: 'No Pasien.',
  name: 'Nama',
  dateOfBirth: 'Tanggal Lahir',
  gender: 'Jenis Kelamin',
  clientInformation: 'Informasi Pasiean',
  confirm: 'Konfirmasi',
  newClient: 'Pasien Baru',
  enterClientInformation: 'Masukkan Informasi Pasien',
  next: 'Selanjutnya',
  pleaseEnterTheRequiredInformation:
    'Silahkan masukkan informasi yang diperlukan',
  yes: 'Ya',
  notYes: 'Tidak',
  pregnancy: 'Kehamilan',
  enterIDNumber: 'Masukkan Nomor ID',
  iDNumber: 'Nomor ID',
  nationality: 'Kewarganegaraan',
  indonesia: 'Indonesia',
  foreigner: 'Warga Negara Asing',
  selectNationality: 'Pilih Kewarganegaraan',
  selectGender: 'Pilih Jenis Kelamin',
  phone: 'Nomor telepon',
  enterPhoneNumber: 'Masukkan Nomor Telepon',
  memo: 'Memo',
  optional: 'Opsional',
  enterSomethingRelatedToTheClient:
    'Masukkan sesuatu yang berhubungan dengan pasien.',
  male: 'Laki-laki',
  female: 'Perempuan',
  passportNumber: 'Nomor Paspor',
  enterPassportNumber: 'Masukkan Nomor Paspor',
  pleaseCheckTheInformationYouEntered:
    'Harap periksa informasi yang Anda masukkan',
  prev: 'Sebelumnya',
  save: 'Simpan',
  manage: 'Atur',
  edit: 'Edit',
  delete: 'Hapus',
  back: 'Kembali',
  information: 'Informasi',
  dateOfRegistration: 'Tanggal Registrasi',
  deleteClient: 'Hapus Pasien',
  deleteClientAndContent: 'Hapus Pasien dan Konten',
  areYouSureYouWantToDeleteThisClient:
    'Apakah Anda yakin ingin menghapus klien ini?',
  itWillBePermanentlyDeleted: 'Ini akan dihapus secara permanen.',
  clinicInformation: 'Informasi Fasilitas',
  enterClinicInformation: 'Masukkan Informasi Fasilitas',
  clinicName: 'Nama Fasilitas',
  enterName: 'Masukkan Nama',
  websiteOptional: 'Situs web (Opsional)',
  faxOptional: 'Fax (Opsional)',
  enterWebsite: 'Masukkan Situs web',
  enterFax: 'Masukkan Nomor Fax',
  streetAddress: 'Alamat Jalan',
  aptSuiteEtcOptional: 'Apt, Suite, Etc (Opsional)',
  city: 'Kota',
  zip: 'ZIP/Kode pos',
  keywordSearch: 'Pencarian Kata kunci',
  manager: 'Staf',
  resetPassword: 'Atur ulang kata sandi',
  support: 'Bantuan',
  signOut: 'Keluar',
  stillHaveQuestions: 'Apakah masih ada pertanyaan?',
  cantFindTheAnswerYouReLookingFor:
    'Tidak dapat menemukan jawaban yang Anda cari?',
  SendUsAnEmailAndWellGetAResponse:
    'Kirimkan kami email dan kami akan mendapat tanggapan.',
  exampleEmail: 'contoh@mail.com',
  clientAddSuccess: 'Berhasil membuat pasien baru',
  testingInProgress: 'Pemeriksaan Sedang Berlangsung',
  newTest: 'Pemeriksaan Baru',
  notice: 'Pemberitahuan',
  TestCompleted: 'Pemeriksaan Selesai',
  seeAll: 'Lihat Semua',
  today: 'Hari ini',
  dateRange: 'Tanggal Periode',
  from: 'Dari',
  to: 'Sampai',
  apply: 'Terapkan',
  testNo: 'No Pemeriksaan.',
  testName: 'Nama Pemeriksaan',
  client: 'Pasien',
  updateSuccess: 'Berhasil memperbaharui',
  deleteSuccess: 'Berhasil dihapus',
  createSuccess: 'Berhasil dibuat',
  testCanceled: 'Pemeriksaan Dibatalkan',
  testProcessing: 'Pemeriksaan Sedang Dikerjakan',
  testList: 'Daftar Pemeriksaan',
  status: 'Status',
  clientName: 'Nama Pasien',
  notification: 'Notifikasi',
  testResultsHaveArrived: 'Hasil pemeriksaan telah tiba.',
  orderHasBeenCompleted: 'Pemesanan telah selesai',
  yesterday: 'Kemarin',
  currentPassword: 'Kata sandi saat ini',
  testCode: 'Kode Pemeriksaan',
  testInformation: 'Informasi Pemeriksaan',
  price: 'Harga',
  requiredDay: 'TAT',
  testItem: 'Item Pemeriksaan',
  testDate: 'Tanggal Pemeriksaan',
  totalPrice: 'Total Harga',
  expectedDate: 'Tanggal yang Ditentukan',
  canceledDate: 'Tanggal Pembatalan',
  testedDate: 'Tanggal Pemeriksaan',
  collectedDate: 'Tanggal Pengumpulan Spesimen',
  reportedDate: 'Tanggal Keluar Hasil',
  result: 'Hasil',
  referenceRange: 'Rentang Referensi',
  comment: 'Komentar',
  downloadTestReport: 'Unduh Hasil Pemeriksaan (PDF)',
  successCancel: 'Berhasil dibatalkan',
  goBack: 'Kembali',
  cancelTest: 'Batalkan Pemesanan',
  thisTestIs: 'Pemeriksaan ini adalah',
  refundable: 'Dapat dikembalikam',
  nonrefundable: 'Tidak dapat dikembalikan',
  reasonForCancellation: 'Alasan Pembatalan',
  eXchangePaymentMethod: 'c: Ubah mertode pembayaran',
  deleteTest: 'Hapus Pesanan',
  areYouSureYouWantToDeleteThisTest:
    'Apakah Anda yakin ingin menghapus pemeriksaan ini?',
  managerType: 'Tipe Staf',
  selectClient: 'Pilih Pasien',
  pleaseSelectAClientToBeTested: 'Silahkan pilih kilen yang akan diperiksa',
  selectTestItem: 'Pilih Item Pemeriksaan',
  pleaseSelectTestItems: 'SIlahkan pilih item pemeriksaan',
  newOrder: 'Pesanan Baru',
  clinicNo: 'No Fasilitas.',
  day: 'hari',
  days: 'hari',
};

const test = {
  no: 'No.',
  testCode: 'Test Code',
  testName: 'Test Name',
  specimen: 'Specimen',
  method: 'Method',
  volume: 'Volume',
  reported: 'TAT',
  orderComplete: 'Order Complete',
  plusOrder: '+ Order',
  orderHistory: 'Order History',
  category: 'Category',
  price: 'Price',
};

const testIND = {
  ...test,
  no: 'No.',
  testCode: 'Kode Pemeriksaan',
  testName: 'Nama Pemeriksaan',
  method: 'Metode',
  orderComplete: 'Pemesanan Selesai',
  plusOrder: '+ Pemesanan',
  price: 'Harga',
};

const staff = {
  staffList: 'Staff List',
  staffType: 'Staff Type',
  staffNo: 'Staff No.',
  all: 'All',
  doctor: 'Doctor',
  nurse: 'Nurse',
  manager: 'Nonmedical Personnel',
  MANAGER_DOCTOR: 'Doctor',
  MANAGER_NURSE: 'Nurse',
  MANAGER_NONE: 'Nonmedical Personnel',
  receptionist: 'Receptionist',
  attendingPhysician: 'Attending Doctor',
  staffInformation: 'Staff Information',
  deleteStaff: 'Delete Staff',
  areYouSureYouWantToDeleteThisStaff:
    'Are you sure you want to delete this staff?',
  selectManager: 'Select Staff',
  pleaseSelectAManager: 'Please select a staff to be tested.',
};
const staffIND = {
  ...staff,
  staffList: 'Daftar Karyawan',
  staffType: 'Tipe Karyawan',
  staffNo: 'No Karyawan.',
  all: 'Semua',
  doctor: 'Dokter',
  nurse: 'Perawat',
  manager: 'Tenaga non-medis',
  MANAGER_DOCTOR: 'Dokter',
  MANAGER_NURSE: 'Perawat',
  MANAGER_NONE: 'Tenaga non-medis',
  staffInformation: 'Informasi Karyawan',
  deleteStaff: 'Hapus Karyawan',
  areYouSureYouWantToDeleteThisStaff:
    'Apakah Anda yakin ingin menghapus Karyawan ini?',
};

const menus = {
  dashboard: 'Dashboard',
  patient: 'Patient',
  addPatient: 'Add Patient',
  patientList: 'Patient List',
  test: 'Test',
  setting: 'Setting',
  testInformation: 'Test Information',
  checkOrder: 'Check Order',
  order: 'Order',
  clinicInformation: 'Profile',
  staffList: 'Staff List',
  notice: 'Notice',
};

const menusIND = {
  ...menus,
  dashboard: 'Dasbor',
  patient: 'Pasien',
  addPatient: 'Tambahkan Pasien',
  patientList: 'Daftar Pasien',
  test: 'Pemeriksaan',
  setting: 'Pengaturan',
  testInformation: 'Informasi Pemeriksaan',
  checkOrder: 'Periksa Pemesanan',
  order: 'Pemesanan',
  clinicInformation: 'Profil',
  staffList: 'Daftar Karyawan',
  notice: 'Pemberitahuan',
};

const notification = {
  minutesAgo: 'minutes ago',
  hoursAgo: 'hours ago',
};

const notificationIND = {
  ...notification,
  minutesAgo: 'menit yang lalu',
  hoursAgo: 'jam yang lalu',
};

export const enTheme = {
  colors,
  intro,
  langs,
  notification,
  menus,
  staff,
  test,
  texts,
};
export const indTheme: typeof enTheme = {
  colors,
  intro,
  langs,
  notification: notificationIND,
  menus: menusIND,
  staff: staffIND,
  test: testIND,
  texts: textsIND,
};

export type themeType = typeof enTheme;
